import styled from 'styled-components';

export const TabList = styled.ol`
  border-bottom: 1px solid var(--tab-color);
  padding-left: 0;
`;